/**
 * Cross-component trigger for the pricing-page worked cost comparison drawers.
 *
 * The pricing page is a server component and the drawer state lives in a single
 * client manager mounted once at the bottom of the page. Trigger links dispatch
 * this event (mirroring the Contact page's prefill pattern) so no state has to
 * be threaded through the card tree.
 */

export type ComparisonTarget = "small" | "team" | "tailored";

export const OPEN_COMPARISON_EVENT = "kleipdata:open-cost-comparison";

export type OpenComparisonDetail = { target: ComparisonTarget };

export function openComparison(target: ComparisonTarget) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<OpenComparisonDetail>(OPEN_COMPARISON_EVENT, {
      detail: { target },
    }),
  );
}

/** Query parameter that deep-links a drawer open, e.g. /pricing?comparison=small */
export const COMPARISON_PARAM = "comparison";

export function isComparisonTarget(v: unknown): v is ComparisonTarget {
  return v === "small" || v === "team" || v === "tailored";
}
